import type { CSSProperties } from 'react';
import { FileCode, Layers } from 'lucide-react';
import './Formats.css';

const FORMATS = [
  {
    icon: <Layers size={32} />,
    name: 'Cadence',
    formats: ['CIS', 'HDL'],
    files: ['.dsn', '.cpm', '.dat exports'],
    description:
      'Full support for Cadence schematic projects. Export netlists using Tools > Create Netlist > PCB Editor format.',
    color: 'var(--accent-primary)',
  },
  {
    icon: <FileCode size={32} />,
    name: 'Altium Designer',
    formats: ['PrjPcb'],
    files: ['.PrjPcb', '.SchDoc'],
    description: 'Native parsing of Altium Designer projects and schematics. No export required.',
    color: 'var(--accent-secondary)',
  },
];

/**
 * Formats section showing supported EDA tools.
 */
export function Formats() {
  return (
    <section id="formats" className="section formats">
      <div className="container">
        <header className="section-header">
          <h2>
            Works with <span className="gradient-text">Your EDA</span>
          </h2>
          <p>Native support for industry-standard EDA formats.</p>
        </header>

        <div className="formats-grid">
          {FORMATS.map((format) => (
            <div key={format.name} className="format-card">
              <div
                className="format-icon"
                style={{ '--format-color': format.color } as CSSProperties}
              >
                {format.icon}
              </div>
              <div className="format-content">
                <h3 className="format-name">{format.name}</h3>
                <div className="format-tags">
                  {format.formats.map((f) => (
                    <span key={f} className="format-tag">
                      {f}
                    </span>
                  ))}
                </div>
                <p className="format-description">{format.description}</p>
                <div className="format-files">
                  {format.files.map((file) => (
                    <code key={file} className="format-file">
                      {file}
                    </code>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
